module.exports = __webpack_public_path__ + "static/media/mesh basket.13.76708e56.png";